type Window = { start: number; end: number };

/** Separate overlapping windows, including the minimum height of short/exact slots. */
export function layoutCalendarSlots<T extends Window>(windows: T[], minimumDuration: number) {
  const laneEnds: number[] = [];
  const blocks = [...windows].sort((a, b) => a.start - b.start || a.end - b.end).map((window) => {
    const visualEnd = Math.max(window.end, window.start + minimumDuration);
    let lane = laneEnds.findIndex((end) => end <= window.start);
    if (lane === -1) lane = laneEnds.length;
    laneEnds[lane] = visualEnd;
    return { ...window, lane };
  });
  return { blocks, laneCount: Math.max(laneEnds.length, 1) };
}
